import { motion } from "framer-motion";
import appStoreIcon from "../../assets/App_Store_(iOS).svg.png";
import { ReactComponent as PlayStoreIcon } from "../../assets/Google_Play_Arrow_logo.svg";

const AppDownloadButtons = () => {
  const ButtonLink = ({ href, children }) => {
    return (
      <a
        href={href}
        className="bg-white text-defaultBlack dark:bg-black dark:text-white px-3 py-3 rounded-lg flex items-center gap-2 shadow-md  active:scale-95 transition-all duration-300"
        target="_blank"
        rel="noopener noreferrer"
      >
        {children}
      </a>
    );
  };

  return (
    <motion.div
      className="flex gap-6 text-sm sm:text-base"
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: "easeOut", delay: 0.8 }}
    >
      <ButtonLink href="https://apple.co/2KnmQCE">
        <img src={appStoreIcon} alt="App Store" className="w-6 h-6" />
        <span className="whitespace-nowrap">App Store</span>
      </ButtonLink>
      <ButtonLink href="http://bit.ly/uplusRW">
        <PlayStoreIcon className="w-6 h-6" />
        <span className=" whitespace-nowrap">Play Store</span>
      </ButtonLink>
    </motion.div>
  );
};

export default AppDownloadButtons;
